import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, Backdrop, CircularProgress } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import YoutubeLinksForm from "../../component/admin/formComponents/YoutubeLinksForm";
import { getLink } from "../../api/getLink";
import { useParams } from "react-router-dom";
import moment from "moment";

export default function Goals() {
  const token = useSelector((state) => state.auth.token);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const fetchBannerData = async (id, token) => {
    try {
      const data = await getLink(id, token);
      if (data.success) {
        formik.setValues({
          category: data.data.category,
          link: data.data.link,
        });
        setLoading(false);
      } else {
        toast.error(data.message);
      }
    } catch (e) {
      toast.error("Error while fetching banner data");
    }
  };

  useEffect(() => {
    if (id) {
      fetchBannerData(id, token);
    } else {
      setLoading(false);
      toast.error("Banner ID is missing");
      navigate("/admin/dashboard/banners");
    }
  }, []);

  const formik = useFormik({
    initialValues: {
      category: "",
      link: "",
    },
    validationSchema: Yup.object().shape({
      category: Yup.number("Please enter integer value")
        .required("Category is Required")
        .typeError("Category is Required"),
      link: Yup.mixed().required("Link is required"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      values.id = id;
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/editLink`,
          values,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          toast.success(response.data.message);
          // toast.success("test");
          setTimeout(() => {
            navigate("/admin/dashboard/youtube-links");
            setLoading(false);
          }, 1000);
        } else {
          toast.error(response.data.message);
        }
      } catch (e) {
        toast.error("error !!");
        setLoading(false);
      }
    },
  });


  return (
    <React.Fragment>
      <ToastContainer />
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress sx={{ color: "#ef364e" }} />
      </Backdrop>
      <Box className="free_votes_page">
        <Box className="page_title">
          <Typography variant="h1" component="h1">
            Update Youtube Link
          </Typography>
        </Box>

        <YoutubeLinksForm formik={formik} edited={true} />
      </Box>
    </React.Fragment>
  );
}
